function pw_post_product_modal_save(personalisationID, thumbURL){

  $(".pwAddToCart").prop("disabled", false);
 $(".product-image-main .image-wrap img").attr("src", thumbURL);
}


$(document).ready(function () {
  var pw_button = $("#pw_cart_button");
  var staticProduct = $("#pw_static_product");

  if ($("body").hasClass("template-product") && pw_button.length){

    function personaliseButton(){

      $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {

        var pw_button_text = $("#pw_cart_button").val();
        if(pw_button_text == "Personalise"){
          $('#pw_cart_button').val('Edit');
          setTimeout(function(){
            $(".pwAddToCart").show();
          },1000);
        }

      });


      // Select the node that will be observed for mutations
      var targetNode = document.getElementById('pw_personalisation_id');

      // Options for the observer (which mutations to observe)
      var config = { attributes: true, childList: true };

      // Callback function to execute when mutations are observed
      var callback = function(mutationsList) {
        //for(var mutation of mutationsList) {
        for(var mutation in mutationsList) {

          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Personalise"){
            $('#pw_cart_button').val('Edit');
            setTimeout(function(){
              $(".pwAddToCart").show();
            },1000);
          }
        }

      };

      // Create an observer instance linked to the callback function
      var observer = new MutationObserver(callback);

      // Start observing the target node for configured mutations
      observer.observe(targetNode, config);
    }

    personaliseButton();

    function pwVariationChange(){

      var pw_cart_button = $("#pw_cart_button").html();
      if (typeof  pw_cart_button !== 'undefined'){
        var pw_button_text = $("#pw_cart_button").val();
        if(pw_button_text == "Edit"){

          var product_image_original = $(".product-image-main .image-wrap img").attr("data-srcset");
          product_image_original = product_image_original.split(",");
          product_image_original = product_image_original[0];
          $(".product-image-main .image-wrap img").attr("src", product_image_original);
          $(".product-image-main .image-wrap img").attr("data-src", product_image_original);
          $(".product-image-main .image-wrap img").attr("srcset", product_image_original);
          $(".product-image-main .image-wrap img").attr("data-zoom",product_image_original );

          if (document.documentMode || /Edge/.test(navigator.userAgent)) {
            $("#pw_cart_button").prop('value', 'Personalise');
          } else{
            $('#pw_cart_button').val('Personalise');
          }


          setTimeout(function(){
            $(".shopify-payment-button__button, .pwAddToCart").hide();
          },1000);
        }
      }

    }
    $(".select-wrapper select").on("change", function(e){
      pwVariationChange();
    });

  }
})